import { BaseApi } from '@/shared/api/baseApi';
import { ENTITY_CONFIGS } from '@/shared/constants/entities';
import type { Discount, DiscountFormData } from '../types';

const discountsApiInstance = new BaseApi<Discount, DiscountFormData>(
  ENTITY_CONFIGS.discounts.endpoints,
);

export const discountsApi = {
  getList: discountsApiInstance.getList.bind(discountsApiInstance),
  getOne: discountsApiInstance.getOne.bind(discountsApiInstance),
  create: discountsApiInstance.create.bind(discountsApiInstance),
  update: discountsApiInstance.update.bind(discountsApiInstance),
  delete: discountsApiInstance.delete.bind(discountsApiInstance),
};
